import React from "react";
import MeetUsWrapper from "Components/MeetUsWrapper";
import styles from "./style.module.scss";
import MeetUsCoinLogo from "Utils/Assets/Images/meetuscoinlogo.png";
import cardExplorerImage1 from "Utils/Assets/Images/cardExplorerImage1.png";
import cardExplorerImage2 from "Utils/Assets/Images/cardExplorerImage2.png";
import cardExplorerImage3 from "Utils/Assets/Images/cardExplorerImage3.png";
import cardExplorerImage4 from "Utils/Assets/Images/cardExplorerImage4.png";
import CheckedCircleIcon from "Utils/Assets/Icons/CheckedCircleIcon";
import { motion } from "framer-motion";

const InvestRealEstate = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                ease: [0.25, 1, 0.5, 1],
            },
        },
    };


    const features = [
        "Stake and earn passive income from real estate-backed assets.",
        "Invest in real estate through blockchain technology.",
        "Secure, transparent, and low-cost property transactions.",
        "Seamless property tokenization for fractional ownership.",
    ];

    const cardsData = [
        {
            img: cardExplorerImage1,
            title: "Metaverse Plaza",
            desc: "A bustling hub for social gatherings and networking.",
            aos: "fade-down-right",
        },
        {
            img: cardExplorerImage2,
            title: "Infinity Arena",
            desc: "The ultimate battleground for competitive VR gaming.",
            aos: "fade-down-left",
        },
        {
            img: cardExplorerImage3,
            title: "Neon Market",
            desc: "A vibrant virtual shopping district filled with exclusive stores.",
            aos: "fade-up-right",
        },
        {
            img: cardExplorerImage4,
            title: "Galaxy Hall",
            desc: "A massive event venue for concerts, and influencer showcases.",
            aos: "fade-up-left",
        },
    ];

    return (
        <div className={styles.root}>
            <MeetUsWrapper>
                <div className={styles.contentWrapper}>
                    <motion.div
                        className={styles.card1}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-100px" }}
                        variants={containerVariants}
                    >
                        <motion.h2
                            className={styles.mainTitle}
                            variants={itemVariants}
                        >
                            What is MVR Core Coin?
                        </motion.h2>
                        <motion.p
                            className={styles.mainDescription}
                            variants={itemVariants}
                        >
                            MVR Core Coin is designed exclusively for real
                            estate investments and tokenized real-world assets
                            (RWA) within MeetusVR, enabling users to buy, sell,
                            and stake fractional property ownership in a
                            decentralized way.
                        </motion.p>

                        <div className={styles.featuresList}>
                            {features.map((feature, index) => (
                                <motion.div
                                    key={index}
                                    className={styles.featureItem}
                                    variants={itemVariants}
                                >
                                    <CheckedCircleIcon
                                        className={styles.checkIcon}
                                    />
                                    <span>{feature}</span>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>

                    <div className={styles.card2}>
                        <div className={styles.cardsGrid}>
                            <div className={styles.cardsImage}>
                                {cardsData.slice(0, 2).map((card, index) => (
                                    <motion.div
                                        key={index}
                                        className={styles.card}
                                        data-aos={card.aos}
                                        data-aos-duration="1000"
                                        data-aos-once="false"
                                        whileHover={{
                                            y: -12,
                                            scale: 1.02,
                                            transition: { duration: 0.4 },
                                        }}
                                    >
                                        <img
                                            src={card.img}
                                            alt={card.title}
                                            className={styles.cardImage}
                                        />
                                        <div className={styles.cardContent}>
                                            <h2 className={styles.cardTitle}>
                                                {card.title}
                                            </h2>
                                            <p className={styles.cardDescription}>
                                                {card.desc}
                                            </p>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                            <div className={styles.cardsImage}>
                                {cardsData.slice(2, 4).map((card, index) => (
                                    <motion.div
                                        key={index}
                                        className={styles.card}
                                        data-aos={card.aos}
                                        data-aos-duration="1000"
                                        data-aos-once="false"
                                        whileHover={{
                                            y: -12,
                                            scale: 1.02,
                                            transition: { duration: 0.4 },
                                        }}
                                    >
                                        <img
                                            src={card.img}
                                            alt={card.title}
                                            className={styles.cardImage}
                                        />
                                        <div className={styles.cardContent}>
                                            <h2 className={styles.cardTitle}>
                                                {card.title}
                                            </h2>
                                            <p className={styles.cardDescription}>
                                                {card.desc}
                                            </p>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                            <img
                                src={MeetUsCoinLogo}
                                alt="MeetUs Coin"
                                className={styles.centerLogo}
                            />
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default InvestRealEstate;
